import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";

export default function CardImage(props) {
  if (!props.src) {
    return null;
  }
  console.log(props.src)
  return (
    <div
    style={{
      position: "relative",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "transparent",
      padding: "2vh 0vw 2vh 0vw",
    }}
    >
    {props.src.split("\r\n\r\n").map((s, i) => (
      <div key={i}>
         <div
            style={{ padding: "0px 1vw 0px 1vw" }}
          >
      <LazyLoadImage
					src={s}
          width= "300px"
					alt="description of image"
				>
			</LazyLoadImage>
    </div>
    </div>
  ))}
  </div>
)
}